import getLocalStorageItem from './getLocalStorageItem'
import { lumber } from '@mc-alberta/lumber'
import * as shouldSample from './determineSample'
import { transformAggregatorDataForLumber } from './formatForLumber'

const clone = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return payload
  }

  const clonedPayload = Array.isArray(payload) ? [ ...payload ] : { ...payload }
  Object.keys(clonedPayload).forEach(key => {
    if (key !== 'windowRef') {
      clonedPayload[key] = clone(clonedPayload[key])
    }
  })

  return clonedPayload
}

// TODO: Improve
export function devLogger (namespace) {
  function removeWindowRef (payload) {
    const isObject = payload => (payload && typeof payload === 'object' && !Array.isArray(payload))
    if (!isObject(payload)) { return }

    for (const prop in payload) {
      if (prop === 'windowRef') {
        payload[prop] = '<windowRef>'
      } else if (isObject(payload[prop])) {
        removeWindowRef(payload[prop])
      }
    }
  }

  function log (ns, level, [ title, content ]) {
    if (!getLocalStorageItem('mcsrc.enablelogging')) {
      return
    }

    const clonedContent = clone(content) // FIXME: should be cloned at aggregator level but encountered issues when doing so
    removeWindowRef(clonedContent)
    console.log.apply(
      console,
      [ ns, level ]
        .concat([title, JSON.stringify(clonedContent, null, 2)])
    )
  }

  // custom loggers must provide the following interface:
  return {
    trace: function () {},
    debug: function () { log(namespace, 'debug', arguments) },
    info: function () { log(namespace, 'info', arguments) },
    warn: function () { log(namespace, 'warn', arguments) },
    error: function () { log(namespace, 'error', arguments) },
    extend: function (newNamespace) { return devLogger(namespace + ':' + newNamespace) },
    performance: function (aggregatorData) {
      try {
        const perfData = transformAggregatorDataForLumber(aggregatorData)
        // only log a small selection of perfData to limit overall network calls
        if (shouldLog(aggregatorData)) {
          // in the event of a data transform issue, perfData will be a single object
          if (Array.isArray(perfData)) {
            lumber.info(perfData)
            log(namespace, 'info', ['logging performance', perfData])
          } else {
            lumber.error(perfData)
            log(namespace, 'error', ['performance log failure', perfData])
          }
        } else {
          log(namespace, 'info', ['skipping performance log', perfData])
        }
      } catch (e) { }
    }
  }
}

export function prodLogger (namespace) {
  // custom loggers must provide the following interface:
  // TODO: add lumber integration
  return {
    trace: function () {},
    debug: function () {},
    info: function () {},
    warn: function () {},
    error: function () {},
    extend: function (newNamespace) { return prodLogger(namespace + ':' + newNamespace) },
    performance: function (aggregatorData) {
      try {
        // only log a small selection of perfData to limit overall network calls
        if (shouldLog(aggregatorData)) {
          const perfData = transformAggregatorDataForLumber(aggregatorData)
          // in the event of a data transform issue, perfData will be a single object
          Array.isArray(perfData)
            ? lumber.info(perfData)
            : lumber.error(perfData)
        }
      } catch (e) { }
    }
  }
}

function shouldLog (aggregatorData) {
  const { SAMPLE_SMALL_AMOUNT, SAMPLE_MEDIUM_AMOUNT } = shouldSample
  // sampling is determined once for an entire flow
  // if SAMPLE_SMALL_AMOUNT === true, all performance data gets logged
  // if SAMPLE_MEDIUM_AMOUNT === true, all performance data gets logged except initial methods
  return SAMPLE_SMALL_AMOUNT || (SAMPLE_MEDIUM_AMOUNT && !['loadSdks', 'init', 'isRecognized'].includes(aggregatorData.methodName))
}
